/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section2_Li1Inputs */

const en_terms_section2_li1 = /** @type {(inputs: Terms_Section2_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON viewing, formatting, and minification`)
};

const ko_terms_section2_li1 = /** @type {(inputs: Terms_Section2_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 보기, 포맷팅 및 압축`)
};

const ja_terms_section2_li1 = /** @type {(inputs: Terms_Section2_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONの表示、フォーマット、圧縮`)
};

/**
* | output |
* | --- |
* | "JSON viewing, formatting, and minification" |
*
* @param {Terms_Section2_Li1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const terms_section2_li1 = /** @type {((inputs?: Terms_Section2_Li1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section2_Li1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_section2_li1(inputs)
	if (locale === "ko") return ko_terms_section2_li1(inputs)
	return ja_terms_section2_li1(inputs)
});